// =====================================================
// 📁 POSProductWorkspace.tsx
// =====================================================

import { useState } from 'react';

import { useSale } from '../../../../hooks/sale/useSale';

import { DOCUMENT_TYPE_CODES } from '../../../../constants/documentTypeCodes';

import POSProductSearch from './POSProductSearch';
import POSProductFilters from './POSProductFilters';
import POSProductViewToggle from './POSProductViewToggle';
import POSProductCategories from './POSProductCategories';

import POSProductListView from '../table/ProductListView/POSProductListView';
import POSProductCardView from '../table/ProductCardView/POSProductCardView';

import { ProductPanelItem } from '../../../../types/productpanel/ProductPanelItem';

import POSCreditNoteProductsPanel from '../credit-note/panel/POSCreditNoteProductsPanel';
import POSProductPlaceholder from '../table/POSProductPlaceholder';

interface Props {
  onAddProductClick: (product: ProductPanelItem) => void;
}

const POSProductWorkspace: React.FC<Props> = ({ onAddProductClick }) => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const { form } = useSale();

  // =====================================================
  // 🔹 View Mode
  // =====================================================

  const [viewMode, setViewMode] = useState<'list' | 'cards'>('list');

  // =====================================================
  // 🔹 Flags
  // =====================================================

  const isCreditNote =
    form?.documentType?.code === DOCUMENT_TYPE_CODES.CREDIT_NOTE;

  const hasActiveSale = !!form?.id;

  // =====================================================
  // 🔹 Credit Note Flow
  // =====================================================

  if (isCreditNote) {
    return <POSCreditNoteProductsPanel />;
  }

  // =====================================================
  // 🔹 No Active Sale
  // =====================================================

  if (!hasActiveSale) {
    return (
      <POSProductPlaceholder mode={viewMode === 'list' ? 'list' : 'card'} />
    );
  }

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div className="flex flex-col gap-4">
      {/* ===================================================== */}
      {/* 🔹 Toolbar */}
      {/* ===================================================== */}

      <div
        className="
        flex
        flex-col
        gap-3

        lg:flex-row
        lg:items-center
        lg:justify-between
      "
      >
        <div
          className="
          flex
          flex-1
          flex-col
          gap-3

          sm:flex-row
          sm:items-center
        "
        >
          <POSProductSearch />

          <POSProductFilters />
        </div>

        <div
          className="
          flex
          justify-end

          lg:justify-normal
        "
        >
          <POSProductViewToggle viewMode={viewMode} onChange={setViewMode} />
        </div>
      </div>

      {/* ===================================================== */}
      {/* 🔹 Products Workspace */}
      {/* ===================================================== */}

      <div
        className="
        bg-gray-1

        rounded-2xl

        p-4

        dark:bg-boxdark-2
      "
      >
        {/* Categorías */}

        <POSProductCategories />

        <div className="mt-4">
          {viewMode === 'list' ? (
            <POSProductListView
              onAddProductClick={onAddProductClick}
              mode="list"
            />
          ) : (
            <POSProductCardView
              onAddProductClick={onAddProductClick}
              mode="card"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default POSProductWorkspace;
